import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class GeneralPayeeSettings extends BaseProductSettings {
    restrictNumberOfPayees: boolean = true;
    maximumNumberOfPayees: number = 1;
    restrictInboundPaymentsToPayeesOnly: boolean = true;
    restrictOutboundPaymentsToPayeesOnly: boolean = true;
}